import { render, staticRenderFns } from "./ClinicPharmaceuticals.vue?vue&type=template&id=57da9240"
import script from "./ClinicPharmaceuticals.vue?vue&type=script&lang=js"
export * from "./ClinicPharmaceuticals.vue?vue&type=script&lang=js"
import style0 from "./ClinicPharmaceuticals.vue?vue&type=style&index=0&id=57da9240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports